export default "__VITE_ASSET__Bgi7UGZl__"